export const iconFontAwesomeFilmVideoCircle = (
	<i className="fa-solid fa-circle"></i>
);
